export default (permissionsListKeys, permissions) => {
  return permissionsListKeys.some(permissionListItem => permissions.includes(permissionListItem))
}
